import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getIframeAuthHeaders } from "../utils/sessionTokenUtil";

export interface LifestyleEligibilityResponse {
  isEligible: boolean;
}

export const lifestyleEligibilityApi = createApi({
  reducerPath: "lifestyleEligibility",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v0/users/",
    prepareHeaders: (headers) => {
      Object.entries(getIframeAuthHeaders()).forEach(([key, value]) =>
        headers.set(key, value)
      );
      return headers;
    },
  }),
  tagTypes: [],
  endpoints: (build) => ({
    checkLifestyleEligibility: build.query<LifestyleEligibilityResponse, void>({
      query() {
        return {
          url: "lifestyleEligibility",
          method: "POST",
          body: {},
        };
      },
    }),
  }),
});

export const {
  useCheckLifestyleEligibilityQuery,
} = lifestyleEligibilityApi;
